import React, { useState } from "react";

function EnquiryForm({ submitHandler, filterResult, filterHandler }) {
  const [input, setInput] = useState("");

  const handleChange = (e) => {
    setInput(e.target.value);
    filterHandler(e.target.value);
  };

  const handelChoceEnquiry = (item) => {
    filterHandler("");
    const trimmedItem = item.replace(/\s+/g, " ").trim();
    console.log(trimmedItem + "  " + item);
    setInput(trimmedItem);
    submitHandler(trimmedItem);
    filterHandler("");
  };

  return (
    <React.Fragment>
      <div className="my-5 row d-flex justify-content-center">
        <div className="Enquiry__Form col-lg-8 col-md-12 col-sm-12 col-xs-12">
          <p className="text-right lh-lg h5" style={{ width: "92%" }}>
            خدمة الاستعلام الآلي للناخبين
          </p>
          <div className="form-group d-flex justify-content-start align-items-center">
            <div className="w-75 position-relative">
              <input
                type="text "
                className="form-control"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
                placeholder="ادخل الاسم الثلاثي"
                value={input}
                onChange={handleChange}
              />

              <div className="position-absolute w-100">
                {filterResult !== null
                  ? filterResult.slice(0, 5).map((item, index) => {
                      return (
                        <div
                          className="border-bottom border-dark bg-light text-dark border-2 rounded-pill p-3"
                          key={index}
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            handelChoceEnquiry(item);
                          }}
                        >
                          {item}
                        </div>
                      );
                    })
                  : null}
              </div>
            </div>

            <button
              type="submit"
              className="btn btn-outline-dark mx-2 "
              onClick={() => {
                filterHandler(null);
                submitHandler(input);
              }}
            >
              استعلام
              <i className="fas fa-search"></i>
            </button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default EnquiryForm;
